import { render, staticRenderFns } from "./additional-material-modal.vue?vue&type=template&id=c85b4638&scoped=true&"
import script from "./additional-material-modal.vue?vue&type=script&lang=js&"
export * from "./additional-material-modal.vue?vue&type=script&lang=js&"
import style0 from "./additional-material-modal.vue?vue&type=style&index=0&id=c85b4638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85b4638",
  null
  
)

component.options.__file = "additional-material-modal.vue"
export default component.exports